import { useReducer, type Dispatch } from "react";
import {
  announcementBannerFormReducer,
  initAnnouncementBannerForm,
  type AnnouncementBanner,
  type AnnouncementBannerForm,
  type AnnouncementBannerFormAction,
} from "@winche/shared";

/*
 * Settings' announcement banner form wired to `config/global` (ux-admin-03).
 * Without JSX or relative imports so `scripts/lib/admin-announcement-banner-form.test.mjs`
 * renders it with React in Node.
 */

/**
 * The banner form following `live` (`config/global.announcementBanner`:
 * undefined until the listener answers, null without a banner). A new
 * snapshot reaches the reducer during render, before the card paints: App
 * hands a new object per snapshot and the same one between snapshots, so
 * this runs once per snapshot. The reducer decides what the snapshot changes
 * (the draft while nothing is pending; only `live` otherwise).
 */
export function useAnnouncementBannerForm(
  live: AnnouncementBanner | null | undefined,
): [AnnouncementBannerForm, Dispatch<AnnouncementBannerFormAction>] {
  const [form, dispatch] = useReducer(announcementBannerFormReducer, live, initAnnouncementBannerForm);
  if (form.live !== live) dispatch({ type: "live", banner: live });
  return [form, dispatch];
}
